import { AppConfig } from "./config";

export const prodConfig: AppConfig = {
  graphqlUri: "https://internal.api.ecomon.no",
};
